module.exports = __WEBPACK_EXTERNAL_MODULE_44__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/display/BitmapData","root":["openfl","display","BitmapData"],"commonjs":"openfl/display/BitmapData","commonjs2":"openfl/display/BitmapData"}
// module id = 44
// module chunks = 0